import { AssetClassEnum } from '../../../api/useDefaultAssetAllocationQuery';

export const getAllocations = ({
  AssetClasses,
  Price,
  Quantity,
}: {
  AssetClasses: Record<AssetClassEnum, number>;
  Price: number;
  Quantity: number;
}) => ({
  total: Quantity * Price,
  allocation: Object.entries(AssetClasses).reduce((acc, [assetClassId, value]) => {
    acc[assetClassId] = value / 100;

    return acc;
  }, {} as Record<AssetClassEnum, number>),
});
